var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V16H24V0Z",
    fill: "#2A2FAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0V16H12V0H24Z",
    fill: "#1318A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V8H0V0Z",
    fill: "#2A2FAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.13905 0L24 15.5022V16H23.2123L0 0.9192V0H0.13905Z",
    fill: "#E92B2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4354 16L0 1.424V0.9192L23.2123 16H22.4354ZM0.916028 0L24 14.9974V15.5022L0.13905 0H0.916028Z",
    fill: "#FBFBFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.5022V16H0.787672L24 0.9192V0H23.8609L0 15.5022Z",
    fill: "#E92B2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1.424V0.9192L0.787672 16H1.56464L24 1.424ZM0 14.9974V15.5022L23.8609 0H23.0839L0 14.9974Z",
    fill: "#FBFBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.9192V1.424L12 9.22026V8.71547L24 0.9192Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0839 0H23.8609L12 7.70592V7.20112L23.0839 0Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34657 0L24 14.7116V15.721L0 0.13493V0H1.34657Z",
    fill: "#FBFBFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.7116V15.721L24 0.13493V0H22.6534L0 14.7116Z",
    fill: "#FBFBFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0V0.13493L12 7.92797V6.91856L22.6534 0H24Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2857 0H10.7143V6.7368H0V9.2632H10.7143V16H13.2857V9.2632H24V6.7368H13.2857V0Z",
    fill: "#E92B2B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2857 9.2632V16H12V0H13.2857V6.7368H24V9.2632H13.2857Z",
    fill: "#C60000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.3158H10.2857V0H11.1429V6.7368V7.1579H10.7143H0V6.3158ZM10.2857 16V9.6842H0V8.8421H10.7143H11.1429V9.2632V16H10.2857ZM24 9.6842H13.7143V16H12.8571V9.2632V8.8421H13.2857H24V9.6842ZM13.7143 0V6.3158H24V7.1579H13.2857H12.8571V6.7368V0H13.7143Z",
    fill: "#FBFBFB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 9.6842H13.7143V16H12.8571V9.2632V8.8421H13.2857H24V9.6842ZM13.7143 0V6.3158H24V7.1579H13.2857H12.8571V6.7368V0H13.7143Z",
    fill: "#F0F0F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.8d51ec8fa5a940d3440e0e43389df4a6.svg";
export { ForwardRef as ReactComponent };